import React, { useEffect } from 'react';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import Footer from '../../components/Footer/Footer';
import { images } from '../../components/shared/assets';
import { initializeDragScroll } from '../../utils/interactiveFeatures';
import './DiningMendoza.css';

const DiningMendoza: React.FC = () => {
  useEffect(() => {
    // Initialize horizontal scroll for the carousel
    const cleanup = initializeDragScroll('dining-carousel');
    return cleanup;
  }, []);

  const diningPanels = [
    {
      id: 'restaurant',
      image: images.mendozaRestaurant || images.restaurantFeature,
      title: 'Our Restaurant',
      content: 'Our restaurant, for the exclusive use of Awasi guests, offers a daily menu using the finest local ingredients, adapted to your requirements. We are proud to deliver levels of culinary excellence that define us as members of Relais & Châteaux.'
    },
    {
      id: 'cuisine',
      image: images.mendozaDining2 || images.foodImage,
      title: 'Seasonal Organic Cuisine, farm to table',
      content: 'We are convinced that the best-tasting food is organically grown and harvested. Our organic vegetable garden supplies many of the ingredients used in our kitchen, picked daily depending on the season and what our chef wishes to cook.'
    },
    {
      id: 'chef',
      image: images.chefMendoza || images.teamMember2,
      title: 'Head Chef',
      content: 'Our culinary team creates exceptional dishes using seasonal ingredients from our organic garden and the finest local producers. Each meal reflects our commitment to sustainable, farm-to-table dining.'
    },
    {
      id: 'ingredients',
      image: images.mendozaDining3 || images.foodImage,
      title: 'Organic produce, seasonal flavours',
      content: 'Our menu celebrates the bounty of Mendoza with seasonal ingredients from our organic garden and local producers. Each dish reflects the changing seasons and the beauty of the Uco Valley landscape.'
    }
  ];

  return (
    <div className="dining-page">
      <UnifiedNavigation variant="light" destination="mendoza" />
      
      {/* Horizontal Carousel Section */}
      <section className="dining-carousel-section" data-scroll-section="dining">
        <div 
          id="dining-carousel"
          className="dining-carousel"
        >
          {diningPanels.map((panel, index) => (
            <div key={panel.id} className="dining-panel">
              <div className="dining-panel__image">
                <img src={panel.image} alt={panel.title} />
              </div>
              <div className="dining-panel__content">
                <h2 className="dining-panel__title">{panel.title}</h2>
                <p className="dining-panel__text">{panel.content}</p>
                <button className="dining-panel__cta">CONTACT US</button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <InstagramSection />
      <Footer variant="mendoza" />
    </div>
  );
};

export default DiningMendoza;